export default __webpack_public_path__ + "static/media/clouds.7447fd98.svg";